module.exports = __webpack_public_path__ + "img/1585978341.457c88a8.jpg";